module.exports = __webpack_public_path__ + "img/TaxService.ec90677a.png";